import { ConnectorConfig } from '@/models/ConnectorConfig';

export type ConnectorSyncPhase = 'in_progress' | 'error' | 'idle';

export interface ConnectorSyncStatus {
  status: ConnectorSyncPhase;
  jobId?: string | null;
  error?: string;
  /**
   * Reference timestamp passed to GET /sync-status as `since`. Set when a sync is triggered
   * locally (Date.now() captured pre-POST), or hydrated from connector.lastSyncAt on app boot
   * so refresh-resumed polling still detects completion of the in-flight sync.
   */
  since?: number;
}

export interface ConnectorState {
  connectors: ConnectorConfig[];
  isLoading: boolean;
  error: string | null;
  syncStates: Record<string, ConnectorSyncStatus>;
}

export const connectorState: ConnectorState = {
  connectors: [],
  isLoading: false,
  error: null,
  syncStates: {},
};
